module.exports = __webpack_public_path__ + "assets/language-squares/it-efca1105b996550a4fd79526cb5f0d4e.jpg";